import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCompetency } from 'app/_models/competency.model';
import { CompetencyService } from 'app/_services/competency.service';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'reject-competency-modal',
  templateUrl: './reject-competency-modal.component.html',
})
export class RejectCompetencyModalComponent {
  @Input() competency: UserCompetency;
  @Input() siteOwnerId: number;

  public rejectionReason = '';
  public saveInProgress = false;

  constructor(
    private activeModal: NgbActiveModal,
    private competencyService: CompetencyService,
    private notificationService: NotificationService,
  ) {}

  public closeModal(): void {
    this.activeModal.dismiss();
  }

  public reject(): void {
    if (this.saveInProgress || !this.rejectionReason.trim()) {
      return;
    }

    this.saveInProgress = true;

    this.competencyService.rejectCompetency(
      this.competency.id,
      this.siteOwnerId,
      this.rejectionReason.trim()
    ).subscribe(
      () => {
        this.notificationService.notify('success', 'Competency rejected');
        this.activeModal.close('refresh');
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error rejecting competency');
        this.saveInProgress = false;
      }
    );
  }
}
